export enum REQUEST_TYPE {
  FEATURE = 'request_feature',
  BUG = 'report_bug',
}
